export function getColsClassName(length?: number, options?: { includeExtraColumn?: boolean }) {
  const { includeExtraColumn = false } = options ?? {}
  const total = Math.min(6, Math.max(1, (length ?? 1) + (includeExtraColumn ? 1 : 0)))
  switch (total) {
    case 6:
      return 'grid-cols-6'
    case 5:
      return 'grid-cols-5'
    case 4:
      return 'grid-cols-4'
    case 3:
      return 'grid-cols-3'
    case 2:
      return 'grid-cols-2'
    default:
      return 'grid-cols-1'
  }
}
